import {WorkspaceGetAllResponse} from 'models/workspace.model';
import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {addWorkSpaces, setSelectedWorkSpace, workSpaceSelector} from '../../store/workspace/workSpaceSlice';

export const useWorkSpaceRedux = () => {
    const dispatch = useDispatch();
    const {workspaces, selectedWorkSpace: selectedWorkSpaceRedux} = useSelector(workSpaceSelector);
    const selectedWorkSpace = useMemo(() => {
        return selectedWorkSpaceRedux;
    }, [selectedWorkSpaceRedux]);

    const allWorkSpaces = useMemo(() => {
        return workspaces;
    }, [workspaces]);
    const setWorkSpacesInRedux = useCallback(
        (value: WorkspaceGetAllResponse[]) => {
            dispatch(addWorkSpaces(value));
        },
        [dispatch],
    );

    const setSelectedWorkSpaceInRedux = useCallback(
        (value: WorkspaceGetAllResponse) => {
            dispatch(setSelectedWorkSpace(value));
        },
        [dispatch],
    );
    return {
        setWorkSpacesInRedux,
        setSelectedWorkSpaceInRedux,
        allWorkSpaces,
        selectedWorkSpace,
    };
};
